import { render } from "./Frame.vue?vue&type=template&id=0f6e95ca"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"

import exportComponent from "E:\\VUE\\Extreme Solutions Jawed Projects\\Extreme Solutions Jawed Projects\\WinWin\\WinWin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__